import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

class BoardPlugin extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'BoardPlugin';
  }
}
BoardPlugin.initClass();

export { BoardPlugin };
